import React from 'react';


const SettingItem = ({ 
  label, 
  description, 
  value, 
  onChange, 
  type = 'toggle',
  options = [],
  min,
  max,
  step = 1,
  unit = '',
  preview = false,
  buttonText = 'Action',
  onButtonClick,
  icon
}) => {
  const renderControl = () => {
    switch (type) {
      case 'toggle':
        return (
          <button
            onClick={() => onChange(!value)}
            className={`
              relative inline-flex h-6 w-11 sm:h-7 sm:w-12 items-center rounded-full
              transition-smooth focus:outline-none focus:ring-3 focus:ring-ring focus:ring-offset-2
              ${value ? 'bg-primary' : 'bg-muted'}
            `}
            role="switch"
            aria-checked={value}
            aria-label={label}
          >
            <span
              className={`
                inline-block h-4 w-4 sm:h-5 sm:w-5 transform rounded-full bg-white
                transition-smooth shadow-therapeutic
                ${value ? 'translate-x-6 sm:translate-x-6' : 'translate-x-1'}
              `}
            />
          </button>
        );

      case 'slider':
        return (
          <div className="w-full space-y-2">
            <div className="flex items-center justify-between">
              <input
                type="range"
                min={min}
                max={max}
                step={step}
                value={value}
                onChange={(e) => onChange(Number(e?.target?.value))}
                className="flex-1 accent-primary cursor-pointer"
                aria-label={label}
              />
              <span className="ml-3 sm:ml-4 text-sm sm:text-base font-medium text-foreground whitespace-nowrap min-w-[60px] text-right">
                {value}{unit}
              </span>
            </div>
            {preview && (
              <div className="mt-3 p-3 sm:p-4 bg-muted rounded-lg">
                <p className={`text-foreground transition-smooth`} style={{ fontSize: `${value}px` }}>
                  Preview text at {value}{unit}
                </p>
              </div>
            )}
          </div>
        );

      case 'select':
        return (
          <select
            value={value}
            onChange={(e) => onChange(e?.target?.value)}
            className="
              px-3 py-2 sm:px-4 sm:py-2.5 rounded-lg border border-border bg-background
              text-foreground text-sm sm:text-base
              focus:outline-none focus:ring-3 focus:ring-ring focus:border-ring
              transition-smooth cursor-pointer
            "
            aria-label={label}
          >
            {options?.map((option) => (
              <option key={option?.value} value={option?.value}>
                {option?.label}
              </option>
            ))}
          </select>
        );

      case 'button':
        return (
          <button
            onClick={onButtonClick}
            className="
              px-4 py-2 sm:px-5 sm:py-2.5 rounded-lg
              bg-primary text-white font-medium text-sm sm:text-base
              hover:bg-primary/90 active:bg-primary/80
              focus:outline-none focus:ring-3 focus:ring-ring focus:ring-offset-2
              transition-smooth cursor-pointer
              disabled:opacity-50 disabled:cursor-not-allowed
            "
            aria-label={label}
          >
            {buttonText}
          </button>
        );

      default:
        return null;
    }
  };

  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-4 py-3 sm:py-4 border-b border-border last:border-0">
      <div className="flex-1 min-w-0">
        <label className="block text-sm sm:text-base font-medium text-foreground mb-1">
          {label}
        </label>
        {description && (
          <p className="text-xs sm:text-sm text-muted-foreground">
            {description}
          </p>
        )}
      </div>
      <div className="flex-shrink-0 w-full sm:w-auto">
        {renderControl()}
      </div>
    </div>
  );
};

export default SettingItem;